export default {
  // Tab names
  'tab.main': 'Principal',
  'tab.producers': 'Producteurs',
  'tab.achievements': 'Succes',
  'tab.prestige': 'Prestige',
  'tab.settings': 'Parametres',

  // Header
  'header.bps': '/sec',
  'header.stage': 'Etape',
  'header.tap': 'TAP!',

  // Combo
  'combo.nice': 'Nice!',
  'combo.great': 'Great!',
  'combo.amazing': 'Amazing!',
  'combo.incredible': 'INCREDIBLE!',
  'combo.legendary': 'LEGENDARY!',
  'combo.label': 'Combo',

  // Critical
  'crit.label': 'CRITICAL!',

  // Producers
  'producer.P1': 'Graine',
  'producer.P2': 'Pousse',
  'producer.P3': 'Plant',
  'producer.P4': 'Cafeier',
  'producer.P5': 'Petite Ferme',
  'producer.P6': 'Grande Ferme',
  'producer.P7': 'Torrefaction',
  'producer.P8': 'Usine de Cafe',
  'producer.P9': 'Centre d\'Export',
  'producer.P10': 'Franchise',
  'producer.P11': 'Empire du Cafe',
  'producer.P12': 'Planete Cafe',

  // Tap upgrades
  'upgrade.T1': 'Doigts Rapides',
  'upgrade.T2': 'Gants',
  'upgrade.T3': 'Outils',
  'upgrade.T4': 'Machines',
  'upgrade.T5': 'Robot',
  'upgrade.T6': 'Nanotechnologie',
  'upgrade.T7': 'Recolte Quantique',
  'upgrade.T8': 'Distorsion Temporelle',

  // Prestige upgrades
  'prestige.G1': 'Graine Doree',
  'prestige.G1.desc': 'BPS +1 base',
  'prestige.G2': 'Sol Fertile',
  'prestige.G2.desc': 'Puissance de tap x1.5',
  'prestige.G3': 'Remise Debutant',
  'prestige.G3.desc': 'P1~P3 cout -50%',
  'prestige.G4': 'Croissance Nocturne',
  'prestige.G4.desc': 'Efficacite hors ligne +20%',
  'prestige.G5': 'Culture Rapide',
  'prestige.G5.desc': 'BPS total x2',
  'prestige.G6': 'Mains Chanceuses',
  'prestige.G6.desc': 'Chance critique +3%',
  'prestige.G7': 'Maitre Barista',
  'prestige.G7.desc': 'Puissance de tap x3',
  'prestige.G8': 'Remise de Gros',
  'prestige.G8.desc': 'Tous les couts -20%',
  'prestige.G9': 'Demarrage Rapide',
  'prestige.G9.desc': 'Commencer avec 10 P1~P3',
  'prestige.G10': 'Melange Premium',
  'prestige.G10.desc': 'BPS total x3',
  'prestige.G11': 'Grain du Temps',
  'prestige.G11.desc': 'Efficacite hors ligne 100%',
  'prestige.G12': 'Couronne du Roi Cafe',
  'prestige.G12.desc': 'Production totale x2',
  'prestige.G13': 'Arbre a Grains Dores',
  'prestige.G13.desc': 'Gain de grains dores +20%',
  'prestige.G14': 'Voyage dans le Temps',
  'prestige.G14.desc': 'Commencer a l\'etape 5',
  'prestige.G15': 'Grains Infinis',
  'prestige.G15.desc': 'Production totale x10',
  'prestige.G16': 'Big Bang du Cafe',
  'prestige.G16.desc': 'Gain de grains dores x2',

  // Star upgrades
  'star.S1': 'Fonds de Depart',
  'star.S1.desc': '1M grains au depart',
  'star.S2': 'Or Eternel',
  'star.S2.desc': 'Grains dores x2 permanent',
  'star.S3': 'Benediction Stellaire',
  'star.S3.desc': 'BPS total x5 permanent',
  'star.S4': 'Auto Tap',
  'star.S4.desc': '1 auto tap par seconde',
  'star.S5': 'Maitre du Combo',
  'star.S5.desc': 'Duree du combo 3 sec',
  'star.S6': 'Frappe Mortelle',
  'star.S6.desc': 'Multiplicateur critique x2',
  'star.S7': 'Puissance Cosmique',
  'star.S7.desc': 'Production totale x10 permanent',
  'star.S8': 'Etoile Transcendante',
  'star.S8.desc': 'Bonus d\'ascension x3',

  // Varieties
  'variety.V1': 'Arabica',
  'variety.V2': 'Robusta',
  'variety.V3': 'Liberica',
  'variety.V4': 'Excelsa',
  'variety.V5': 'Geisha',
  'variety.V6': 'Kopi Luwak',
  'variety.V7': 'Blue Mountain',
  'variety.V8': 'Kona',
  'variety.V9': 'Yirgacheffe',
  'variety.V10': 'Peaberry',
  'variety.V11': 'Maragogipe',
  'variety.V12': 'St. Helena',

  // Stages
  'stage.1': 'Jardin de Grand-mere',
  'stage.2': 'Petite Cour',
  'stage.3': 'Ferme de Cafe',
  'stage.4': 'Torrefaction',
  'stage.5': 'Usine de Cafe',
  'stage.6': 'Chaine Mondiale',
  'stage.7': 'Royaume du Cafe',

  // Roasting
  'roast.perfect': 'Torrefaction Parfaite !',
  'roast.dark': 'Torrefaction Foncee',
  'roast.medium': 'Torrefaction Moyenne',
  'roast.light': 'Torrefaction Legere',
  'roast.burnt': 'Brule...',
  'roast.raw': 'Pas assez cuit',
  'roast.tap': 'Tapez pour arreter !',
  'roast.reward': 'Recompense',
  'roast.double': 'Pub pour 2x !',
  'roast.collect': 'Collecter',

  // Achievements
  'ach.tap1': 'Premiers Pas', 'ach.tap1.desc': '100 taps',
  'ach.tap2': 'Mains Occupees', 'ach.tap2.desc': '1 000 taps',
  'ach.tap3': 'Maitre du Tap', 'ach.tap3.desc': '10 000 taps',
  'ach.tap4': 'Doigt Legendaire', 'ach.tap4.desc': '100 000 taps',
  'ach.tap5': 'Dieu du Tap', 'ach.tap5.desc': '1 000 000 taps',
  'ach.tap6': 'Mains Rapides', 'ach.tap6.desc': '5 taps par seconde',
  'ach.tap7': 'Mains Eclair', 'ach.tap7.desc': '10 taps par seconde',
  'ach.tap8': 'Mains Divines', 'ach.tap8.desc': '15 taps par seconde',
  'ach.tap9': 'Maniaque du Combo', 'ach.tap9.desc': 'Atteindre 20 combo',
  'ach.tap10': 'Combo Legendaire', 'ach.tap10.desc': 'Atteindre 50 combo',

  'ach.prod1': 'Premiere Recolte', 'ach.prod1.desc': '1K grains recoltes',
  'ach.prod2': 'Petit Succes', 'ach.prod2.desc': '100K grains recoltes',
  'ach.prod3': 'Ferme en Croissance', 'ach.prod3.desc': '10M grains recoltes',
  'ach.prod4': 'Magnat du Cafe', 'ach.prod4.desc': '1B grains recoltes',
  'ach.prod5': 'Empereur du Cafe', 'ach.prod5.desc': '1T grains recoltes',
  'ach.prod6': 'Debut d\'Automatisation', 'ach.prod6.desc': 'Atteindre 100 BPS',
  'ach.prod7': 'Usine en Marche', 'ach.prod7.desc': 'Atteindre 10K BPS',
  'ach.prod8': 'Revolution Industrielle', 'ach.prod8.desc': 'Atteindre 1M BPS',
  'ach.prod9': 'Production Mondiale', 'ach.prod9.desc': 'Atteindre 100M BPS',
  'ach.prod10': 'Production Cosmique', 'ach.prod10.desc': 'Atteindre 10B BPS',

  'ach.bld1': 'Fermier Debutant', 'ach.bld1.desc': 'Posseder 1 de P1~P4',
  'ach.bld2': 'Fermier Intermediaire', 'ach.bld2.desc': 'Posseder 1 de P1~P8',
  'ach.bld3': 'Fermier Maitre', 'ach.bld3.desc': 'Posseder tous les producteurs',
  'ach.bld4': 'Investissement Cible', 'ach.bld4.desc': 'Posseder 10 d\'un type',
  'ach.bld5': 'Achat en Gros', 'ach.bld5.desc': 'Posseder 25 d\'un type',
  'ach.bld6': 'Collectionneur', 'ach.bld6.desc': 'Posseder 50 d\'un type',
  'ach.bld7': 'Monopoliste', 'ach.bld7.desc': 'Posseder 100 d\'un type',
  'ach.bld8': 'Expansion', 'ach.bld8.desc': '100 producteurs au total',
  'ach.bld9': 'Empire Commercial', 'ach.bld9.desc': '500 producteurs au total',
  'ach.bld10': 'Domination Mondiale', 'ach.bld10.desc': '1000 producteurs au total',

  'ach.pres1': 'Premiere Renaissance', 'ach.pres1.desc': '1 prestige',
  'ach.pres2': 'Gout de la Repetition', 'ach.pres2.desc': '3 prestiges',
  'ach.pres3': 'Maitre du Prestige', 'ach.pres3.desc': '5 prestiges',
  'ach.pres4': 'Cycle Sans Fin', 'ach.pres4.desc': '10 prestiges',
  'ach.pres5': 'Anneau Eternel', 'ach.pres5.desc': '20 prestiges',
  'ach.pres6': 'Expert en Reincarnation', 'ach.pres6.desc': '50 prestiges',
  'ach.pres7': 'Recolte Doree', 'ach.pres7.desc': '10 grains dores d\'un coup',
  'ach.pres8': 'Tempete Doree', 'ach.pres8.desc': '100 grains dores d\'un coup',
  'ach.pres9': 'Speedrunner', 'ach.pres9.desc': 'Prestige en 30 min',
  'ach.pres10': 'Renaissance Eclair', 'ach.pres10.desc': 'Prestige en 15 min',

  'ach.spec1': 'Chasseur de Cerises', 'ach.spec1.desc': 'Taper cerise doree 1 fois',
  'ach.spec2': 'Maniaque des Cerises', 'ach.spec2.desc': 'Taper cerise doree 10 fois',
  'ach.spec3': 'Maitre des Cerises', 'ach.spec3.desc': 'Taper cerise doree 50 fois',
  'ach.spec4': 'Torrefaction Debutant', 'ach.spec4.desc': 'Torrefaction parfaite 1 fois',
  'ach.spec5': 'Torrefaction Expert', 'ach.spec5.desc': 'Torrefaction parfaite 10 fois',
  'ach.spec6': 'Collectionneur de Varietes', 'ach.spec6.desc': 'Collecter 5 varietes',
  'ach.spec7': 'Docteur en Cafe', 'ach.spec7.desc': 'Collecter les 12 varietes',
  'ach.spec8': 'Fermier Assidu', 'ach.spec8.desc': '1 heure de jeu total',
  'ach.spec9': 'Accro au Cafe', 'ach.spec9.desc': '24 heures de jeu total',
  'ach.spec10': '7 Jours Consecutifs', 'ach.spec10.desc': '7 jours de suite',

  'ach.mile1': 'Proprietaire de Ferme', 'ach.mile1.desc': 'Atteindre etape 3',
  'ach.mile2': 'Entrepreneur du Cafe', 'ach.mile2.desc': 'Atteindre etape 5',
  'ach.mile3': 'Roi du Cafe', 'ach.mile3.desc': 'Atteindre etape 7',
  'ach.mile4': 'Transcendant', 'ach.mile4.desc': 'Premiere ascension stellaire',
  'ach.mile5': 'Perfectionniste', 'ach.mile5.desc': 'Debloquer 50 succes',

  // Achievement categories
  'ach.cat.tapping': 'Taps',
  'ach.cat.production': 'Production',
  'ach.cat.producers': 'Producteurs',
  'ach.cat.prestige': 'Prestige',
  'ach.cat.special': 'Special',
  'ach.cat.milestone': 'Jalons',

  // Prestige panel
  'prestige.title': 'Renaissance du Torrefie',
  'prestige.desc': 'Renaissez pour gagner des grains dores et repartir plus fort !',
  'prestige.goldenBeans': 'Grains Dores',
  'prestige.expected': 'Gain Prevu',
  'prestige.rebirth': 'Renaissance',
  'prestige.upgrades': 'Ameliorations de Prestige',
  'prestige.locked': 'Deblocage a l\'etape 7',
  'prestige.adBonus': 'Pub pour +30%',

  // Ascension panel
  'ascend.title': 'Ascension Stellaire',
  'ascend.desc': 'Ascendez pour gagner de la poussiere d\'etoile et tout transcender !',
  'ascend.starDust': 'Poussiere d\'Etoile',
  'ascend.expected': 'Gain Prevu',
  'ascend.ascend': 'Ascension',
  'ascend.upgrades': 'Ameliorations Stellaires',
  'ascend.locked': '10 renaissances + 100 grains dores requis',

  // Settings
  'settings.bgm': 'Musique de Fond',
  'settings.sfx': 'Effets Sonores',
  'settings.vibration': 'Vibration',
  'settings.language': 'Langue',
  'settings.reset': 'Reinitialiser les Donnees',
  'settings.resetConfirm': 'Voulez-vous vraiment supprimer toutes les donnees ?',
  'settings.credits': 'Credits',
  'settings.version': 'Version',

  // Boost buttons
  'boost.tap': 'Boost de Tap',
  'boost.bps': 'Boost de Production',

  // Offline
  'offline.title': 'Bon retour !',
  'offline.earned': 'Gains Hors Ligne',
  'offline.time': 'Temps d\'Absence',
  'offline.collect': 'Collecter',
  'offline.adX3': 'Pub pour x3',

  // General
  'buy': 'Acheter',
  'max': 'Max',
  'level': 'Nv.',
  'locked': 'Verrouille',
  'owned': 'Possede',
  'on': 'ON',
  'off': 'OFF',
} as const;
